/*
 * Dominick Horsewear - drill-down in het mobiele menu (Equilin).
 * Zet het tweede niveau van de drawer (accordeon) om in een schuivend paneel
 * met de categorienaam en een terug-pijl, zoals dochorse.nl.
 * Plaatst daarnaast twee uitgelichte collecties onderin, uit het navigatiemenu
 * "Mega-menu foto's" (zie snippets/custom-drawer-promo.liquid).
 * Terugdraaien? Verwijder dit bestand + de regels onderin layout/theme.liquid.
 */
(function () {
  if (window.__dominickDrawerDrilldown) return;
  window.__dominickDrawerDrilldown = true;

  var ANIMATION_MS = 400;

  function text(node) {
    var el = node.querySelector('.menu-drawer__menu-item-text');
    return (el || node).textContent.trim();
  }

  function buildPanel(accordion) {
    var details = accordion.querySelector('details');
    if (!details) return;
    var summary = details.querySelector('summary');
    var list = details.querySelector('ul');
    if (!summary || !list) return;

    var title = text(summary);

    var container = document.createElement('details');
    container.className = 'menu-drawer__menu-container cdd-container';

    var newSummary = document.createElement('summary');
    newSummary.className =
      'menu-drawer__menu-item menu-drawer__menu-item--parent focus-inset cdd-summary';
    newSummary.innerHTML =
      '<span class="menu-drawer__menu-item-text"></span><span class="cdd-chevron" aria-hidden="true"></span>';
    newSummary.querySelector('.menu-drawer__menu-item-text').textContent = title;

    var panel = document.createElement('div');
    panel.className = 'menu-drawer__submenu has-submenu gradient motion-reduce cdd-panel';
    panel.setAttribute('tabindex', '-1');

    var inner = document.createElement('div');
    inner.className = 'menu-drawer__inner-submenu';

    var nav = document.createElement('div');
    nav.className = 'menu-drawer__nav-buttons';

    var back = document.createElement('button');
    back.type = 'button';
    back.className = 'button menu-drawer__back-button focus-inset cdd-back';
    back.innerHTML =
      '<span class="cdd-chevron cdd-chevron--back" aria-hidden="true"></span><span class="menu-drawer__menu-item-text"></span>';
    back.querySelector('.menu-drawer__menu-item-text').textContent = title;

    var close = document.createElement('button');
    close.type = 'button';
    close.className = 'button menu-drawer__close-button cdd-close';
    close.setAttribute('aria-label', 'Sluiten');

    nav.appendChild(back);
    nav.appendChild(close);

    list.classList.remove('details-content', 'menu-drawer__menu--grandchildlist');
    list.classList.add('menu-drawer__menu--childlist');

    inner.appendChild(nav);
    inner.appendChild(list);
    panel.appendChild(inner);
    container.appendChild(newSummary);
    container.appendChild(panel);

    // De <li> stond ingesteld als accordeon-rij; terug naar een gewone menurij,
    // zodat marges en regelhoogte gelijk lopen met de rest van het menu.
    var row = accordion.closest('li');
    if (row) {
      row.classList.remove('menu-drawer__list-item--deep', 'menu-drawer__list-item--flat');
      row.classList.add('menu-drawer__list-item');
    }

    // Subcategorieen op dezelfde tekstgrootte als de categorieen.
    var items = list.querySelectorAll('.menu-drawer__menu-item--child');
    for (var i = 0; i < items.length; i++) {
      items[i].classList.remove('menu-drawer__menu-item--child');
      items[i].classList.add('menu-drawer__menu-item--parent');
    }

    accordion.replaceWith(container);
  }

  function addPromoTiles() {
    var template = document.getElementById('cdd-promo-template');
    if (!template || !template.content) return;

    var drawers = document.querySelectorAll('[data-header-drawer]');
    for (var i = 0; i < drawers.length; i++) {
      var targets = [drawers[i]];
      var panels = drawers[i].querySelectorAll('.menu-drawer__inner-submenu');
      for (var p = 0; p < panels.length; p++) targets.push(panels[p]);

      for (var t = 0; t < targets.length; t++) {
        var alreadyThere = false;
        var children = targets[t].children;
        for (var c = 0; c < children.length; c++) {
          if (children[c].classList.contains('cdd-promo-row')) alreadyThere = true;
        }
        if (!alreadyThere) targets[t].appendChild(template.content.cloneNode(true));
      }
    }
  }

  function enhance() {
    var drawers = document.querySelectorAll('[data-header-drawer]');
    for (var i = 0; i < drawers.length; i++) {
      var accordions = drawers[i].querySelectorAll('accordion-custom');
      for (var j = 0; j < accordions.length; j++) buildPanel(accordions[j]);
    }
    addPromoTiles();
  }

  function openDetails(details) {
    details.open = true;
    var summary = details.querySelector('summary');
    if (summary) summary.setAttribute('aria-expanded', 'true');
    requestAnimationFrame(function () {
      details.classList.add('menu-open');
    });
  }

  function closeDetails(details) {
    details.classList.remove('menu-open');
    var summary = details.querySelector('summary');
    if (summary) summary.setAttribute('aria-expanded', 'false');
    setTimeout(function () {
      details.open = false;
    }, ANIMATION_MS);
  }

  function closeNested(scope) {
    var open = scope.querySelectorAll('.cdd-container.menu-open');
    for (var i = 0; i < open.length; i++) closeDetails(open[i]);
  }

  document.addEventListener(
    'click',
    function (event) {
      var target = event.target;
      if (!target || typeof target.closest !== 'function') return;

      var summary = target.closest('.cdd-summary');
      if (summary) {
        event.preventDefault();
        var container = summary.closest('.cdd-container');
        if (container) {
          if (container.classList.contains('menu-open')) closeDetails(container);
          else openDetails(container);
        }
        return;
      }

      var back = target.closest('.cdd-back');
      if (back) {
        event.preventDefault();
        var own = back.closest('.cdd-container');
        if (own) closeDetails(own);
        return;
      }

      // Terug- of sluitknop van het thema: onze eigen panelen ook resetten.
      var themeNav = target.closest('.menu-drawer__back-button, .menu-drawer__close-button');
      if (themeNav) {
        var drawer = themeNav.closest('[data-header-drawer]');
        if (drawer) closeNested(drawer);
      }
    },
    true
  );

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', enhance);
  } else {
    enhance();
  }

  // Het thema kan de header opnieuw renderen (theme-editor, section rendering).
  document.addEventListener('shopify:section:load', enhance);
})();
